<template>
  <CDataTable
      :fields="fields"
      :items="items"
      :items-per-page="7"
      items-per-page-select
      pagination
      sorter
      table-filter>
    <template #courseCode="{item}">
      <td>
        <label>{{ item.courseCode }}</label>
      </td>
    </template>
    <template #no="{item, index}">
      <td>
        {{ index + 1 }}
      </td>
    </template>
    <template #topic_name="{item}">
      <td>
        <label>{{ item.topic_name }}</label>
      </td>
    </template>
    <template #questionTopic="{item}">
      <td v-if="item.questionTopic">
        {{ item.questionTopic.name }}
      </td>
      <td v-else>
        -
      </td>
    </template>
    <template #questionType="{item}">
      <td v-if="item.questionType">
        {{ item.questionType.name }}
      </td>
      <td v-else>
        -
      </td>
    </template>
    <template #keyword="{item}">
      <td>
        <label>{{ item.keyword.length > 0 ? getKeyword(item.keyword) : "-" }}</label>
      </td>
    </template>
    <template #quality="{item}">
      <td>
        <label>{{ item.quality === undefined ? "-" : item.quality }}</label>
      </td>
    </template>
    <template #difficulty="{item}">
      <td>
        <label>{{ item.difficulty === undefined ? "-" : item.difficulty }}</label>
      </td>
    </template>
    <template #course_name="{item}">
      <td>
        <label>{{ item.course_name }}</label>
      </td>
    </template>
    <template #name="{item}">
      <td>
        <label>{{ item.name }}</label>
      </td>
    </template>
    <template #year="{item}">
      <td>
        <label>{{ item.year }}</label>
      </td>
    </template>
    <template #activeStatus="{item}">
      <td>
        <label
            :class="item.activeStatus ? 'text-success' : 'text-danger'"
            @click="teacher('changeStatus',item)"
            class="font-weight-bold status">{{ item.activeStatus ? "Activated" : "Deactivated" }}</label>
      </td>
    </template>
    <template #fileReceiver="{item}">
      <td v-if="item.fileReceiver === undefined">
        {{ item.fileReceiver === undefined ? "-" : item.fileReceiver }}
      </td>
      <td v-else>
        {{ profileId === item.fileReceiverId ? "You" : item.fileReceiver }}
      </td>
    </template>
    <template #fileSender="{item}">
      <td>
        {{ profileId === item.fileSenderId ? "You" : item.fileSender }}
      </td>
    </template>
    <template #fileStatus="{item}">
      <td>
        <CBadge :color="getBadgeFileStatus(item.isReceived)" class="p-1" style="width: 60%">
          <span class="text-white">{{ getFileStatus(item.isReceived) }}</span>
        </CBadge>
      </td>
    </template>
    <template #fileOptions="{item}">
      <td v-if="item.isReceived">
        <CButton @click="openFile(item.fileUrl)" class="text-white mr-2" color="info">
          <CIcon height="36" name="cil-description"/>
        </CButton>
        <CButton @click="deleteFile(item.fileId)" color="danger">
          <CIcon height="36" name="cil-trash"/>
        </CButton>
      </td>
      <td v-if="!item.isReceived">
        <CButton @click="acceptFile(item.fileId,item.fileUrl)" class="text-white mr-2"
                 color="success" v-if="profileId !== item.fileSenderId">
          <CIcon height="36" name="cil-check-circle"/>
        </CButton>
        <CButton @click="openFile(item.fileUrl)" class="text-white mr-2" color="info" v-else>
          <CIcon height="36" name="cil-description"/>
        </CButton>
        <CButton @click="deleteFile(item.fileId)" color="danger" v-if="profileId === item.fileSenderId">
          <CIcon height="36" name="cil-trash"/>
        </CButton>
      </td>
    </template>
    <template #createdAt="{item}">
      <td>
        {{ getDate(item.createdAt) }}
      </td>
    </template>
    <template #status="{item}">
      <td>
        <CBadge :color="getBadge(item.status)">
          {{ item.status }}
        </CBadge>
      </td>
    </template>
    <template #editOptions="{item}">
      <td>
        <!--        <CButton @click="editItem(item)" class="text-white mr-2" color="info"-->
        <!--                 v-c-tooltip="{content: 'Exam items', active:false }">-->
        <!--          <CIcon height="36" name="cil-list"/>-->
        <!--        </CButton>-->
        <CButton @click="editItem(item)" class="text-white mr-2" color="warning"
                 v-c-tooltip="{content: 'Edit', active:false }">
          <CIcon height="36" name="cil-pencil"/>
        </CButton>
        <CButton @click="deleteItem(item)" color="danger" v-c-tooltip="{content: 'Delete', active:false }">
          <CIcon height="36" name="cil-trash"/>
        </CButton>
      </td>
    </template>
    <template #examSetNameAnalytic="{item}">
      <td>
        {{ item.examSet.name }}
      </td>
    </template>
    <template #examSetName="{item}">
      <td>
        {{ item.examSetName }}
      </td>
    </template>

    <template #analyticOptions="{item,index}">
      <td>
        <CButton @click="analyticReports('VIEW',item)" class="text-white mr-2" color="info"
                 v-c-tooltip="{content: 'View Analytic report', active:false }">
          <CIcon height="36" name="cil-description"/>
        </CButton>
        <CButton @click="analyticReports('DELETE',item._id)" color="danger"
                 v-c-tooltip="{content: 'Delete examset', active:false }">
          <CIcon height="36" name="cil-trash"/>
        </CButton>
      </td>
    </template>

    <template #examSetOptions="{item}">
      <td>
        <CButton @click="examset('description',item)" class="text-white mr-2" color="info"
                 v-c-tooltip="{content: 'Examset details', active:false }">
          <CIcon height="36" name="cil-description"/>
        </CButton>
        <!--        <CButton @click="examset('download',item)" class="text-white mr-2" color="info" v-c-tooltip="{content: 'Analysis results', active:false }">-->
        <!--          <CIcon height="36" name="cil-cloud-download"/>-->
        <!--        </CButton>-->
        <CButton @click="examset('delete',item)" color="danger"
                 v-c-tooltip="{content: 'Delete examset', active:false }">
          <CIcon height="36" name="cil-trash"/>
        </CButton>
      </td>
    </template>

    <template #teacherOptions="{item}">
      <td>
        <CButton @click="teacher('change',item)" class="mr-1" color="success"
                 v-c-tooltip="{content: 'Change Password', active:false }">
          <CIcon height="36" name="cil-lock-locked"/>
        </CButton>
        <CButton @click="teacher('edit',item)" class="text-white mr-1" color="warning"
                 v-c-tooltip="{content: 'Edit', active:false }">
          <CIcon height="36" name="cil-pencil"/>
        </CButton>
        <CButton @click="teacher('delete',item)" color="danger" v-c-tooltip="{content: 'Delete', active:false }">
          <CIcon height="36" name="cil-trash"/>
        </CButton>
      </td>
    </template>
  </CDataTable>
</template>

<script>
export default {
  name: "InformationTable",
  props: {
    items: Array,
    fields: Array,
    profileId: String
  },
  data() {
    return {
      // collapseDuration: 0,
      topicFields: [
        {key: "topicName", label: "Topic"},
        {key: "options", label: "#", _style: "text-align:right"}
      ]
    }
  },
  methods: {
    getDate(date) {
      const fullDate = date.slice(0, 10).split("-")
      if(fullDate[2] === undefined){
        return fullDate[0]
      }else{
        return  fullDate[2]+"/"+fullDate[1]+"/"+fullDate[0]
      }
    },
    acceptFile(fileId, url) {
      this.$emit("fileAccepted", fileId)
      window.open(url, '_blank');
    },
    openFile(url) {
      window.open(url, '_blank');
    },
    deleteFile(fileId) {
      this.$emit("deleteFile", fileId)
    },
    teacher(status, items) {
      let body = {};
      body.items = items
      if (status === "edit") {
        body.action = "edit"
      } else if (status === "delete") {
        body.action = "delete"
      } else if (status === "change") {
        body.action = "change"
      } else if (status === "changeStatus") {
        body.action = "changeStatus"
      }
      this.$emit("teacher", body)
    },
    getBadge(status) {
      switch (status) {
        case 'Active':
          return 'success'
        case 'Inactive':
          return 'secondary'
        case 'Pending':
          return 'warning'
        case 'Banned':
          return 'danger'
        default:
          'primary'
      }
    },
    getBadgeFileStatus(status) {
      if (status) {
        return "success"
      } else if (!status) {
        return "warning"
      } else {
        return "warning"
      }
    },
    getFileStatus(status) {
      if (status) {
        return "received"
      } else if (!status) {
        return "sent"
      } else {
        return "sent"
      }
    },
    editItem(item) {
      if (item._id) {
        this.$emit("editItem", item._id)
      } else if (item.topic_id) {
        this.$emit("editItem", item)
      }
    },
    deleteItem(item) {
      if (item._id) {
        this.$emit("deleteItem", item._id)
      } else if (item.topic_id) {
        this.$emit("deleteItem", item.topic_id)
      }
    },
    changeStatus(item) {
      this.$emit("teacher", item)
    },
    examset(type, item) {
      if (type === "description") {
        this.$emit("examSetAction", {type: "description", item})
      } else if (type === "download") {
        this.$emit("examSetAction", {type: "download", item})
      } else if (type === "delete") {
        this.$emit("examSetAction", {type: "delete", item})
      }
    },
    analyticReports(type, item) {
      if (type === "VIEW") {
        this.$emit("viewAnalyticReport", item)
      } else if (type === "DELETE") {
        this.$emit("deleteAnalyticReport", item)
      }
    },
    getKeyword(keyword) {
      let words = ""
      keyword.forEach((word, index) => {
        words += word.name
        if (index !== keyword.length - 1) {
          words += ", "
        }
      })
      return words
    }
  }
}
</script>

<style scoped>
.status {
  cursor: pointer;
}
</style>
